export default __webpack_public_path__ + "static/media/fa-brands-400.3696430d.woff";